module.exports = __webpack_public_path__ + "img/login-bg.7506a78e.png";